<template lang='pug'>
.v-search-small.search-small
	.blur-wrap
		button.btn.btn--icon.btn--gray.btn-search(type="button" @click="searchOpen")
			.btn__icon
				v-svg-icon.icon-search(icon="search")
		.blur
	transition(name="show-aside")
		.filter-aside.filter-aside--search(v-if="isOpen")
			.filter-aside__overlay(@click.stop="closeSearch")
			.filter-aside__inner.scrollbar
				.filter-aside__head
					.filter-aside__title(v-if="search && search.title") {{search.title}}
					button.filter-aside__close(@click.stop="closeSearch")
						v-svg-icon.filter-aiside__close-icon(icon="cross")
				.filter-aside__body
					form.search-small__form(@submit.prevent="relocate" @reset.prevent="close")
						v-field(:field="field" v-model="localQuery" class="search-small__field")
						button.search-small__close-btn(v-if="localQuery && localQuery.length > 2" aria-label="Очистить" type="reset")
							v-svg-icon.search-small__close-btn-icon(icon="close-sm")
						//-button.search-small__submit-btn(aria-label="Найти" type="submit")
							v-svg-icon.search-small__submit-btn-icon(icon="icon-lens")

					.search-small__result(v-if="localQuery && localQuery.length > 2")
						template(v-if="search && search.items && search.items.length"
								v-for="(result, resultIndex) in search.items" :key="resultIndex")
							.search-small__products
								.search-small__title(v-if="result.title") {{result.title}}
								.search-small__list(v-if="localQuery && localQuery.length > 2 && result.items && result.items.length")
									template(v-for="(item, index) in result.items" :key="index" )
										.search-small__item
											a.search-small__link(:href="item.href || undefined")
												.search-small__link-text(v-if="item.text") {{item.text}}
												.search-small__link-count(v-if="item.count") {{item.count}}
						.search-small__action(v-if="search.link")
							a.btn.btn--transparent.btn--fw.btn--xl(:href="search.link") {{search.linkText || 'Все результаты'}}
						.search-small__message(v-if="localQuery && localQuery.length > 2 && search.items && !search.items.length")
								| По вашему запросу ничего не найдено
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from '../scripts/controller/controller.js';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			loading: false,
			localQuery: null,
			searchTimeout: null,
			isOpen: false,
			localUrl: null,
			field: {
				'type': 'search',
				'label': null,
				'inputmode': 'search',
				'placeholder': 'Поиск'
			},
			search: {
				remote: null,
				query: null,
				link: null,
				suggestions: []
			}
		};
	},

	watch: {
		localQuery() {
			this.searchInput();
		}
	},

	created() {
		document.addEventListener('click', this.clickOutside);
		controller.events.on('search-small-open', this.open);
		controller.events.on('search-small-close', this.close);
	},

	unmounted() {
		document.removeEventListener('click', this.clickOutside);
	},

	methods: {
		searchOpen() {
			this.isOpen = true;
		},
		closeSearch() {
			this.isOpen = false;
		},

		configurateUrl() {
			if (this.search.link) {
				let searchUrl = new URL(window.location.protocol + window.location.host + this.search.link);
				searchUrl.searchParams.set('q', this.localQuery);
				this.localUrl = searchUrl;
			}
		},

		relocate() {
			this.configurateUrl();
			window.location = this.localUrl;
		},

		open() {
			document.body.classList.add('state--search-small-open');
		},

		close() {
			this.localQuery = null;
			this.search.suggestions = null;
			document.body.classList.remove('state--search-small-open');
		},

		clickOutside(e) {
			if (!this.$el.contains(e.target)) {
				controller.closeSearchSmall();
			}
		},

		searchInput() {
			this.configurateUrl();
			clearTimeout(this.searchTimeout);
			if (this.localQuery) {
				controller.openSearchSmall();
				this.searchTimeout = setTimeout(this.requestDataLoad, 200);
			} else {
				controller.closeSearchSmall();
			}
		},

		requestDataLoad() {
			this.dataLoad({
				url: this.search.remote,
				delay: true,
				data: {
					query: this.localQuery,
					bxajaxid: this.bxajaxid
				}
			});
		},

		dataSet(data) {
			this.configurateUrl();
			if (!this.search.remote) {
				this.search = data;
				return;
			}
			this.search = data;
		}
	}
};
</script>